'use client';
import NotFound from '@/views/NotFound';
export default function NotFoundPage() { return <NotFound />; }
